import SettingBase from '../settings/util/SettingBase'

class LocationController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'location'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-location']) {
      this.hasACL[this.acl['setting-location'][key]] = true;
    }
  }
}
export default LocationController;


// WEBPACK FOOTER //
// ./client/app/components/location/location.controller.js